<script lang="ts">
	import tippy, { type Instance } from 'tippy.js';
	import { onMount } from 'svelte';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { linkToggle } from '$lib/actions/linkToggle';
	import { page } from '$app/stores';
	import type { Collection } from '$lib/types/Collections';

	export let collection: Collection;

	let target: HTMLDivElement;
	let content: HTMLDivElement;

	let tippyInstance: Instance;
	onMount(() => {
		tippyInstance = tippy(target, {
			content: content,
			interactive: true,
			arrow: true,
			placement: 'bottom',
			appendTo: document.body,
		});
		return () => {
			tippyInstance.destroy();
		};
	});
</script>

<div bind:this={target} class="target">
	<slot />
	<span style="margin-block-end: 4px">
		<Icon icon="dropdown-arrow" size="20" clickable />
	</span>
</div>
<div style="display: none;">
	<div bind:this={content}>
		<ul class="tags">
			{#each collection?.tags ?? [] as tag}
				<li>
					<a
						on:click={() => tippyInstance.hide()}
						use:linkToggle={$page}
						href={`/${$page.params.hubPrefix}/${collection.slug}?tag=${tag}`}
					>
						#{tag}
					</a>
				</li>
			{/each}
		</ul>
	</div>
</div>

<style>
	ul {
		max-block-size: 45vh;
		margin-block-start: -10px;
		overflow-y: scroll;
		border-radius: var(--gutterSmaller);
		background-color: var(--grayLightest);
		box-shadow: rgb(0 0 0 / 20%) 0 0 18px 0;
	}

	a {
		display: block;
		align-items: center;
		justify-content: flex-start;
		inline-size: 200px;
		padding-block: var(--gutterSmall);
		padding-inline: var(--gutterMedium);
		color: var(--grayDark);
		font-size: var(--fontSizeSmall);
		text-decoration: none;
	}

	a:hover {
		background-color: var(--grayLighter);
	}

	li:not(:last-child) {
		border-block-end: 2px solid var(--grayLighter);
	}

	.target {
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
	}
</style>
